module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"requestLogin":"DEN TRENDMANAGER KENNENLERNEN","contact":"https://www.trendone.com/plattform"},"en":{"requestLogin":"GET TO KNOW THE TRENDMANAGER","contact":"https://www.trendone.com/en/platform"}}')
  delete Component.options._Ctor
}
